import { RadixDialog } from '@/components/RadixDialog';
import styled from 'styled-components';
import CloseIconSvg from '../../../../../../public/images/icons/close.svg';

export const MobilePopupHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.spacing[20]};
  padding-right: ${({ theme }) => theme.spacing[20]};
  background: ${({ theme }) => theme.colors.darkBlue};
  height: 67px;
  overflow: hidden;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    display: none;
  }
`;

export const Logo = styled.img.attrs({
  src: '/images/icons/monitor_logo.svg',
  alt: 'Parcel Monitor Tracking Logo',
})`
  display: block;
  width: 188px;
  height: 22px;
  object-fit: contain;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    display: none;
  }
`;

export const CloseIcon = styled(CloseIconSvg).attrs({ width: 24, height: 24 })({
  cursor: 'pointer',

  path: {
    fillOpacity: 'unset',
  },
});

export const CloseButton = styled(RadixDialog.Close)({
  border: 'none',
  background: 'transparent',
  display: 'flex',
  padding: 0,
});
